import { MARKETING_CONSENT } from '../components/now-cookie-disclaimer/cookie-disclaimer-constants';

export class CookieUtil {
  private static readonly sekProTag = 86400;
  private static readonly umrechnungsfaktorMsZuS = 1000;

  /**
   * Gibt den Wert eines Cookies anhand dessen Namen zurück.
   * Existiert kein Cookie zu dem angegebenen Namen wird ein leerer String zurückgegeben.
   *
   * @param name cookieName
   */
  public static getCookieValue(name: string): string {
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((c) => c.trim().split('=')[0] === name);
    const cookieValue = cookie?.split('=')[1];
    return cookieValue ?? '';
  }

  public static writeCookieConsent(name: string, value: string) {
    const age = name === MARKETING_CONSENT ? 180 : 30;
    const cookieMaxAge = age * this.sekProTag; // in seconds
    const cookieExpiresDate = new Date(Date.now() + cookieMaxAge * this.umrechnungsfaktorMsZuS);
    this.writeCookieValue(name, cookieMaxAge, cookieExpiresDate, value);
  }

  /**
   * Schreibt den übergebenen Wert in den festgelegten Cookie.
   * @param name Der Name des Cookies
   * @param maxAge Das maximale Alter des Cookies
   * @param expires Gibt an, wann der Cookie ungültig wird
   * @param value Der Wert, der in den Cookie geschrieben werden soll
   */
  public static writeCookieValue(name: string, maxAge: number, expires: Date, value: string): void {
    document.cookie = `${name}=${value};path=/;max-age=${maxAge};expires=${expires.toUTCString()};SameSite=Lax;`;
  }
}
